import { createFileRoute } from '@tanstack/react-router';
import { PayrollComponentModule } from '@/modules/payroll-component';

export const Route = createFileRoute('/(dashboard)/_dashboard/finance/payroll-component')({
  component: PayrollComponentModule,
});
